<div class="container-fluid">
  <div class="row mb-4">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-7">
              <div #chartContainer style="width: 100%; height: 300px;"></div>
            </div>
            <div class="col-md-5">
              <div #pieChartContainer style="width: 100%; height: 264px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header mb-1">
          <h3 class="card-title small-title">Detalle de Gastos por Aprobar</h3>
        </div>
        <div class="card-body pt-2 pb-1">
          <p-treeTable
            [value]="treeTableData"
            [tableStyle]="{ 'min-width': '100%' }"
            [scrollable]="true"
            scrollHeight="600px">
            <ng-template pTemplate="header">
              <tr>
                <th>Descripción / Jerarquía</th>
                <th>Valor</th>
                <th>Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
              <tr>
                <td>
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  {{ rowData.label }}
                </td>
                <td style="text-align:right">{{ rowData.valor ? (rowData.valor | currency:'USD':'symbol':'1.0-0':'es-EC') : '' }}</td>
                <td>
                  <button *ngIf="!rowData.aprobado" class="btn btn-primary btn-sm" (click)="approveTreeNode(rowNode)">Aprobar</button>
                  <span *ngIf="rowData.aprobado" class="text-success"><i class="fas fa-check"></i></span>
                </td>
              </tr>
            </ng-template>
          </p-treeTable>
        </div>
      </div>
    </div>
  </div>
</div> 